import React, { memo } from 'react';
import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { Block } from '../../components/core';
import { GrowthSimulationContent } from './growth-simulation-content';
import { GrowthSimulationHeader } from './growth-simulation-header';

export const GrowthSimulationBlock = memo(function InternalGrowthSimulationBlock({ id }: { id: string }) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <GrowthSimulationHeader id={id} />
      </Block.Header>

      <Block.Content id={id} errorWrappers={[...COMMON_ERROR_WRAPPERS]}>
        <GrowthSimulationContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
